export class AsyncResult {
  static succeeded(result: Office.AsyncResult<any>): boolean {
    return result.status === Office.AsyncResultStatus.Succeeded;
  }
}
